import { BookingIdRemarkRuleListItem } from "../../../../integrated-client/models";

interface IRemarksTableData {
  records: Array<BookingIdRemarkRuleListItem>;
  totalItems?: number;
}

export class RemarksTableData implements IRemarksTableData {
  records: Array<BookingIdRemarkRuleListItem>;
  totalItems?: number;

  constructor() {
    this.records = [];
  }
}
